import moment from 'moment'

import { EventModel } from 'app/models/newDelegation/eventModel'


let uidCounter = 0

export function generateUid(): string {
  return `_evt_${Date.now()}_${++uidCounter}`
}

export function ensureUid(event: EventModel): EventModel {
  if (event._uid) return event
  return { ...event, _uid: generateUid() }
}

export function ensureUids(events: EventModel[]): EventModel[] {
  let changed = false
  const result = events.map((e) => {
    if (e._uid) return e
    changed = true
    return { ...e, _uid: generateUid() }
  })
  return changed ? result : events
}

export function matchEvent(a: EventModel, b: EventModel): boolean {
  if (a.id != null && b.id != null && a.id === b.id) return true
  if (a._uid && b._uid && a._uid === b._uid) return true
  return false
}


export function eventKey(event: EventModel): string {
  if (event._uid) return event._uid
  if (event.id != null) return `id-${event.id}`
  return `t-${moment(event.date as any).valueOf()}-${event.tripEvent}`
}
